/* eslint-disable react/no-danger */
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { MathJax } from "better-react-mathjax";
import ModalImage from "react-modal-image";
import React, { useEffect, useRef, useState } from "react";
import ReactAudioPlayer from "react-audio-player";
import { FormattedMessage } from "react-intl";
import Link from "next/link";
import orderBy from "lodash/orderBy";
// import LessonRelated from "./LessonRelated";
import dynamic from "next/dynamic";
import NoDataComponent from "../../common/components/NoData";
import ModalComplain from "../../questionAndAnswer/components/ModalComplain";
import IconFlagReport from "../../../../public/assets/icons/IconFlagReport";
import { REPORT_QUIZ } from "../../common/utils/constant";
import { eventTracking } from "../../../firebase/firebaseConfig";
import { TCommonState } from "../../common/utils/type";
import { commonActions } from "../../common/redux/actions";
import { FacebookShareLike } from "../../Default/layout/components/Provider";
import GoogleAd from "../../common/components/GoogleAd";

const LessonRelated = dynamic(() => import("./LessonRelated"));

const mappingEtruriaNumber = {
  1: "I",
  2: "II",
  3: "III",
  4: "IV",
  5: "V",
  6: "VI",
  7: "VII",
  8: "VIII",
  9: "IX",
  10: "X"
};

const getHeadingTagList = (items) => {
  const contentString = items
    ?.map((e) => e?.content)
    ?.flat()
    .toString();

  const h4List = contentString?.match(/<h4(.)*<\/h4>/g);
  const h3List = contentString?.match(/<h3(.)*<\/h3>/g);
  const h2List = contentString?.match(/<h2(.)*<\/h2>/g);
  const allHeadingTag = contentString?.match(/<h(2|3|4)(.)*<\/h(2|3|4)>/g);
  return {
    h4List,
    h3List,
    h2List,
    allHeadingTag
  };
};

const TableOfContentLesson = ({ lessonItems, listIndexing }) => {
  const { h3List, h2List } = getHeadingTagList(lessonItems);
  const scrollFunc = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  };

  const getItemNoTags = (item) => item?.replace(/(<([^>]+)>)/gi, "");

  if (listIndexing?.length === 0) return null;
  return (
    <Box className="flex justify-center pt-1 mt-[20px]">
      <Box className="md:w-[444px] h-max border-[1px] p-4 bg-gray border-gray400">
        <div className="flex justify-center pb-2">
          <span className="text-black1 text-[18px] font-[600]">
            <FormattedMessage id="Lesson.TableOfContent.title" />:
          </span>
        </div>
        <MathJax dynamic inline>
          <Box className="flex flex-col">
            {listIndexing?.map((item, idx) => (
              <Typography
                key={idx}
                className={`${
                  h3List?.find((e) => getItemNoTags(e)?.includes(getItemNoTags(item))) && "ml-4 py-2"
                } py-[2px] pl-4 hover:cursor-pointer hover:underline text-green2`}
                onClick={() =>
                  scrollFunc(
                    h2List?.find((e) => e?.includes(getItemNoTags(item)))
                      ? `indexing_h2_${h2List.findIndex((e) => getItemNoTags(e)?.includes(getItemNoTags(item)))}`
                      : `indexing_h3_${h3List.findIndex((e) => getItemNoTags(e)?.includes(getItemNoTags(item)))}`
                  )
                }
              >
                {h2List?.find((e) => getItemNoTags(e)?.includes(getItemNoTags(item))) &&
                  (item.match(/[1-9]./g)
                    ? getItemNoTags(item)
                    : `${mappingEtruriaNumber[h2List.indexOf(item) + 1]}. ${getItemNoTags(item)}`)}
                {h3List?.find((e) => getItemNoTags(e)?.includes(getItemNoTags(item))) && (
                  <span className="py-4">{getItemNoTags(item)}</span>
                )}
              </Typography>
            ))}
          </Box>{" "}
        </MathJax>
      </Box>
    </Box>
  );
};

const getLessonItemsClean = (lessons) => {
  // sửa để tốt cho SEO + làm mục lục
  const { h4List, h3List, h2List, allHeadingTag } = getHeadingTagList(lessons?.items);
  const isOldLesson = !lessons?.items?.some((e) => e?.content?.startsWith("<h2>") || e?.content?.startsWith("<h3>"));
  const lessonItems: any = [];
  const listIndexing: any[] = [];
  lessons?.items?.forEach((item) => {
    let itemObj = item;
    let newContent: any = item.content;
    if (isOldLesson) {
      if (item?.content?.includes("<h4 ") || item?.content?.includes("<h4>")) {
        h4List?.forEach((e) => {
          if (item?.content?.includes(e)) {
            const elementReplace = e
              ?.replace("<h4", `<h2 id='indexing_h2_${h4List?.indexOf(e)}' `)
              ?.replace("</h4>", "</h2>");
            newContent = newContent?.replace(e, elementReplace);
            listIndexing.push({ ele: elementReplace, ordinal: allHeadingTag?.indexOf(e) });
          }
        });
        itemObj = {
          ...item,
          content: newContent
        };
      }
      // else if (item?.content?.startsWith("<p>") && item?.content?.includes("color: #0000ff")) {
      //   itemObj = {
      //     ...item,
      //     content: item?.content?.replace("<p>", `<h3 id='indexing_h3_${indexH3}'>`)?.replace("</p>", "</h3>"),
      //     ordinalH3: indexH3
      //   };
      //   indexH3 += 1;
      // }
    } else {
      if (item?.content?.includes("<h2")) {
        h2List.forEach((e, idx) => {
          if (item?.content?.includes(e)) {
            newContent = newContent?.replace(e, e?.replace("<h2", `<h2 id='indexing_h2_${idx}' `));
            listIndexing.push({
              ele: e?.replace("<h2", `<h2 id='indexing_h2_${idx}' `),
              ordinal: allHeadingTag?.indexOf(e)
            });
          }
        });
        itemObj = {
          ...item,
          content: newContent
        };
      }
      if (item?.content?.includes("<h3")) {
        h3List.forEach((e, idx) => {
          if (item?.content?.includes(e)) {
            newContent = newContent?.replace(e, e?.replace("<h3", `<h3 id='indexing_h3_${idx}'`));
            listIndexing.push({
              ele: e?.replace("<h3", `<h3 id='indexing_h3_${idx}' `),
              ordinal: allHeadingTag?.indexOf(e)
            });
          }
        });
        itemObj = {
          ...item,
          content: newContent
        };
      }
    }
    lessonItems.push(itemObj);
  });
  const listIndexingSorted = orderBy(listIndexing, "ordinal").map((e) => e?.ele);
  return { lessonItems, listIndexingSorted };
};

export default function LessonDetailView({ lessons }: any) {
  const dispatch = useDispatch();
  const dataUserInfos = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);
  const { hideDialogSurvey } = useSelector((state: { commonNew: TCommonState }) => state.commonNew);
  const [openModalReport, setOpenModalReport] = React.useState(false);

  const [width, setWidth] = useState(0);
  const adWrapperRef = useRef<HTMLDivElement>(null);

  const { lessonItems, listIndexingSorted } = getLessonItemsClean(lessons);

  const handleOpenModalReport = () => {
    setOpenModalReport(true);
  };
  const handleCloseModalReport = () => {
    setOpenModalReport(false);
  };

  React.useEffect(() => {
    if (hideDialogSurvey !== openModalReport) {
      dispatch(commonActions.handleHideDialogSurvey(openModalReport));
    }
  }, [openModalReport]);

  useEffect(() => {
    if (adWrapperRef.current) {
      setWidth(adWrapperRef.current?.clientWidth);
    }
  }, []);

  return (
    <>
      {lessons?.items?.length > 0 ? (
        <Box
          className="sm:w-screen md:w-full"
          style={{
            display: "flex",
            flexDirection: "column",
            background: "white",
            borderRadius: "6px",
            padding: "24px 16px",
            minHeight: 120
          }}
        >
          <Box display="flex" justifyContent="space-between" className="gap-2">
            <Typography
              variant="h1"
              sx={{ textAlign: "justify", width: lessons.reference?.direct_link_slug ? "90%" : "100%" }}
              className="text-[24px] font-bold"
            >
              {lessons?.title}
            </Typography>
            <div className="flex h-[32px]">
              {lessons.reference?.direct_link_slug && (
                <Link href={lessons.reference?.direct_link_slug} className="flex item-center">
                  <a
                    href={lessons.reference?.direct_link_slug}
                    target="_blank"
                    rel="noreferrer"
                    className="ml-[5px] bg-accept items-center flex justify-center rounded-[20px] w-[108px] text-white"
                  >
                    <FormattedMessage id="Exercise" />
                  </a>
                </Link>
              )}
              {dataUserInfos?.member && (
                <button
                  type="button"
                  className="ml-[10px] cursor-pointer"
                  onClick={() => eventTracking("select_lesson_error", {}, () => handleOpenModalReport())}
                >
                  <IconFlagReport />
                </button>
              )}
            </div>
          </Box>
          <Box mt={3}>
            <FacebookShareLike />
          </Box>
          <TableOfContentLesson lessonItems={lessonItems} listIndexing={listIndexingSorted} />
          <Box mt={3} className="sm:w-[95vw] md:w-full md:overflow-hidden sm:overflow-x-scroll scrollbar-hide">
            {lessonItems?.map((element: any, index) => {
              switch (element.content_type) {
                case "image":
                  return (
                    <div key={index} className="flex justify-center font-[400] items-center">
                      <ModalImage
                        small={element?.content}
                        large={element?.content}
                        alt="thitot.vn"
                        hideDownload
                        hideZoom
                      />
                    </div>
                  );
                case "audio":
                  return (
                    <div key={index}>
                      <ReactAudioPlayer src={element?.content} controls volume={0} />
                    </div>
                  );
                case "reference":
                  return (
                    <div
                      className="text-blue2 hover:underline"
                      dangerouslySetInnerHTML={{ __html: element?.content }}
                    />
                  );
                default:
                  if (!element?.content) return <div />;
                  return (
                    <MathJax dynamic inline key={index}>
                      <div dangerouslySetInnerHTML={{ __html: element?.content }} />
                    </MathJax>
                  );
              }
            })}
          </Box>
          <Box mt={3}>
            <FacebookShareLike />
          </Box>
          <Box className="flex justify-center w-full max-h-[192px]" ref={adWrapperRef}>
            <GoogleAd
              style={{
                display: "block",
                height: 192,
                width
              }}
              slot={process.env.NEXT_PUBLIC_GOOGLE_AD_SLOT_ARTICLE}
              adTypeTracking="ads_banner_native_ads_view"
            />
          </Box>
          <Box className="sm:w-[92vw] md:w-full">
            <LessonRelated relatedLesson={lessons?.related_lesson} />
          </Box>
        </Box>
      ) : (
        <div className="box-cover">
          <NoDataComponent />
        </div>
      )}
      {openModalReport && (
        <ModalComplain
          open={openModalReport}
          handleClose={handleCloseModalReport}
          title={<FormattedMessage id="title.report.quiz" />}
          subtitle={<FormattedMessage id="subtitle.report.quiz" />}
          type={REPORT_QUIZ}
          openTextInput
          topic={lessons}
          setOpenModalReport={setOpenModalReport}
        />
      )}
    </>
  );
}
